import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { FONTS } from "../../Constant/Theme";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: ${Colors.whiteThemeColor};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
export const PopularCourseContent = styled.div`
  width: 97%;
  min-width: 480px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 10px;
`;
export const PopularCourse = styled.div`
  width: 22%;
  min-width: 120px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 1px 3px 3px #6666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const StudentList = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 200px;
  background-color: ${Colors.whiteThemeColor};
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;
export const StatusDiv = styled.section`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid
    ${(props) =>
      props?.status === "Completed"
        ? Colors.primary
        : props?.status === "On Progress"
        ? "red"
        : "#FEC64F"};
  box-sizing: border-box;
  background-color: ${(props) =>
    props?.status === "Completed"
      ? `rgba(1, 122, 115, 0.15)`
      : props?.status === "On Progress"
      ? "rgba(255, 0, 0, 0.15)"
      : "rgba(254, 198, 79, 0.15)"};
  min-width: 80px;
  p {
    ${FONTS.SemiBold12};
    color: ${(props) =>
      props?.status === "Completed"
        ? Colors.primary
        : props?.status === "On Progress"
        ? "red"
        : "#FEC64F"};
  }
`;
